import { useMemo } from 'react';
import { useGuard } from './useGuard';
import { SidebarMenuItem } from '../Types/Layout.type';
import { menuList } from '../Data/Layout/SidebarMenuList';

export const useFilteredMenu = () => {
   const { hasRole } = useGuard();

   const filteredMenuList = useMemo(() => {
      return menuList.map((section) => ({
         ...section,
         items:
            section.items
               ?.map((item) => {
                  const filteredChildren = item.children?.filter(
                     (child) => !child.role || hasRole(child.role)
                  );

                  return {
                     ...item,
                     children: filteredChildren?.length
                        ? filteredChildren
                        : undefined,
                  };
               })
               .filter((item) => !item.role || hasRole(item.role)) || [],
      }));
   }, [hasRole]);

   return filteredMenuList;
};
